const env = process.env.ENV || 'development'

export let urlBase
export let payment
export let scheduling
export let pet
export let partner
export let user
export let assetPrefix = ''
export const basePath = '/servicos'

if (env === 'development') {
  urlBase = 'https://pwa-service-qa.cobasi.com.br/'
  payment = 'http://localhost:3006'
  scheduling = 'http://localhost:3004'
  pet = 'http://localhost:3003'
  partner = 'http://localhost:3002'
  user = 'http://localhost:3005'
  assetPrefix = 'http://localhost:3000/servicos'
} else if (env === 'test') {
  urlBase = 'https://pwa-service-qa.cobasi.com.br/'
  payment = 'http://localhost:3006'
  scheduling = 'http://localhost:3004'
  pet = 'http://localhost:3003'
  partner = 'http://localhost:3002'
  user = 'http://localhost:3005'
  assetPrefix = 'http://localhost:3000/servicos'
} else if (env === 'staging') {
  urlBase = 'https://pwa-service-qa.cobasi.com.br/'
  payment = 'https://payment-ms-qa.cobasi.com.br'
  scheduling = 'https://scheduler-qa.cobasi.com.br'
  pet = 'https://pet-qa.cobasi.com.br'
  partner = 'https://partner-qa.cobasi.com.br'
  user = 'https://user-qa.cobasi.com.br'
  assetPrefix = 'https://www.cobasi.com.br/ambiente-qa/servicos'
} else {
  urlBase = 'https://mid-back.cobasi.com.br/'
  payment = 'https://payment-ms.cobasi.com.br'
  scheduling = 'https://www.cobasi.com.br/external-apis/scheduler'
  pet = 'https://www.cobasi.com.br/external-apis/pet'
  partner = 'https://www.cobasi.com.br/external-apis/partner'
  user = 'https://user.cobasi.com.br'
  assetPrefix = 'https://www.cobasi.com.br/servicos'
}

export default {
  urlBase,
  payment,
  scheduling,
  pet,
  partner,
  user,
  assetPrefix,
  basePath
}
